import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScrollWrapper } from "@/components/SmoothScrollWrapper";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import api from "@/lib/api";
import { initTracking, trackPageView } from "@/lib/tracking";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import { LoginPage, SignupPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/AuthPages";
import { SellPage, PartnerHubPage, StorefrontPage } from "@/pages/PartnerPages";
import { AboutPage, CategoriesPage, FaqPage } from "@/pages/InfoPages";
import {
  PrivacyPage, TermsPage, RefundPage, LicenseTermsPage, PartnerTermsPage, DisclaimerPage, ContactPage,
} from "@/pages/LegalPages";

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    api
      .get("/settings")
      .then(({ data }) => {
        initTracking(data || {});
        trackPageView();
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScrollWrapper>
            <ScrollToTop />
            <Analytics />
            <Toaster position="top-center" theme="dark" richColors />
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:slug" element={<ProductDetailPage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/sell" element={<SellPage />} />
              <Route path="/store/:slug" element={<StorefrontPage />} />

              {/* Auth */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              {/* Protected */}
              <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="/partner" element={<ProtectedRoute role="partner"><PartnerHubPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminPage /></ProtectedRoute>} />

              {/* Legal */}
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/refund" element={<RefundPage />} />
              <Route path="/license-terms" element={<LicenseTermsPage />} />
              <Route path="/partner-terms" element={<PartnerTermsPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
            </Routes>
            <Footer />
          </SmoothScrollWrapper>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
